import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { validate_id, allow_num } from '@/utils/validations';
import { useToast } from '@/components/Toast/useToast';
import { useConfirmation } from '@/components/Toast/useConfirmation';

export default {
  name: 'TelephoneForm',
  setup() {
    const { showSuccess, showError } = useToast();
    const { showConfirmation } = useConfirmation();
    
    return {
      showSuccess,
      showError,
      showConfirmation
    };
  },
  data() {
    return {
      id_number: '',
      error: ''
    };
  },
  emits: ['service_status_complete'],
  methods: {
    allow_num(event) {
      this.id_number = allow_num(event);
    },
    handle_id_input(id_number) {
      this.id_number = id_number;
    },
    submit_form() {
      if (!this.id_number.trim()) {
        $('.id-message').removeClass('d-none');
        setTimeout(() => {
          $('.id-message').addClass('d-none');
        }, 3000);
        return false;
      }
      if (!validate_id(this.id_number)) {
        $('.invalid-message').removeClass('d-none');
        setTimeout(() => {
          $('.invalid-message').addClass('d-none');
        }, 3000);
        return false;
      }
      this.telephone_api();
    },
    telephone_api() {
      const TOKEN = localStorage.getItem('token');
      const TELEPHONE_API = `${API_BASE_URL}/verify_api/instant_verify_api/telephone_list/`;
      this.error = '';
      $.ajax({
        url: TELEPHONE_API,
        method: 'POST',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        data: JSON.stringify({
          id_number: this.id_number
        }),
        beforeSend: () => {
          Swal.fire({
            text: 'Loading ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
          });
        },
        success: () => {
          Swal.close();
          this.showSuccess('Successful', 'Telephone list ran successfully', 3000);
          this.$emit('service_status_complete');
          this.id_number = '';
        },
        error: (error) => {
          Swal.close();
          let error_message = 'Something went wrong!';
          if (error.responseJSON && error.responseJSON.message) {
            error_message = error.responseJSON.message;
          }
          this.showError('Error', error_message);
        }
      });
    }
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
  }
};
